// file: src/components/questions/QuestionTree.js
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { indentInsertQuestion } from "../../services/questionService";

const QuestionTree = ({ questions, onRefresh, onEdit, onDelete }) => {
  const buildTree = (items, parentId = null) =>
    items
      .filter((item) => item.parent_id === parentId)
      .sort((a, b) => a.path_index.localeCompare(b.path_index))
      .map((item) => ({
        ...item,
        children: buildTree(items, item.id),
      }));

  const tree = buildTree(questions);

  const handleAddBefore = async (q) => {
    const desc = prompt("Masukkan deskripsi pertanyaan baru (sebelum index ini):");
    if (!desc) return;
    try {
      await indentInsertQuestion({
        parentPath: q.path_index.split(".").slice(0, -1).join("."),
        insertAt: parseInt(q.path_index.split(".").pop()),
        description: desc,
        weight: 1,
        has_child: 0,
        child_format: "radio",
        parent_id: q.parent_id || null,
        mode: "before",
      });
      toast.success("Pertanyaan berhasil ditambah sebelum index");
      onRefresh();
    } catch {
      toast.error("Gagal tambah pertanyaan sebelum");
    }
  };

  const handleAddAfter = async (q) => {
    const desc = prompt("Masukkan deskripsi pertanyaan baru (sesudah index ini):");
    if (!desc) return;
    try {
      await indentInsertQuestion({
        parentPath: q.path_index.split(".").slice(0, -1).join("."),
        insertAt: parseInt(q.path_index.split(".").pop()) + 1,
        description: desc,
        weight: 1,
        has_child: 0,
        child_format: "radio",
        parent_id: q.parent_id || null,
        mode: "after",
      });
      toast.success("Pertanyaan berhasil ditambah sesudah index");
      onRefresh();
    } catch {
      toast.error("Gagal tambah pertanyaan sesudah");
    }
  };

  const handleAddChild = async (q) => {
    const desc = prompt("Masukkan deskripsi pertanyaan baru (anak):");
    if (!desc) return;
    try {
      await indentInsertQuestion({
        parentPath: q.path_index,
        insertAt: 1,
        description: desc,
        weight: 1,
        has_child: 0,
        child_format: "radio",
        parent_id: q.id,
        mode: "child",
      });
      toast.success("Pertanyaan anak berhasil ditambahkan");
      onRefresh();
    } catch {
      toast.error("Gagal tambah pertanyaan anak");
    }
  };

  const TreeNode = ({ node }) => {
    const [open, setOpen] = useState(true);

    return (
      <div className="ms-2">
        <div className="d-flex align-items-center gap-2">
          {node.children?.length > 0 && (
            <i
              className={`fas fa-chevron-${open ? "down" : "right"}`}
              style={{ cursor: "pointer" }}
              onClick={() => setOpen(!open)}
            />
          )}
          <span>
            {node.path_index} - {node.description}
          </span>
          <Button
            size="sm"
            variant="outline-success"
            title="Tambah sebelum"
            onClick={() => handleAddBefore(node)}
          >
            <i className="fas fa-arrow-up"></i>
          </Button>
          <Button
            size="sm"
            variant="outline-primary"
            title="Tambah sesudah"
            onClick={() => handleAddAfter(node)}
          >
            <i className="fas fa-arrow-down"></i>
          </Button>
          <Button
            size="sm"
            variant="outline-warning"
            title="Tambah anak"
            onClick={() => handleAddChild(node)}
          >
            <i className="fas fa-level-down-alt"></i>
          </Button>
          <Button
            size="sm"
            variant="outline-info"
            onClick={() => onEdit(node)}
          >
            <i className="fas fa-edit"></i>
          </Button>
          <Button
            size="sm"
            variant="outline-danger"
            onClick={() => onDelete(node)}
          >
            <i className="fas fa-trash"></i>
          </Button>
        </div>
        {open && node.children?.length > 0 && (
          <div className="ms-3 border-start ps-2">
            {node.children.map((child) => (
              <TreeNode key={child.id} node={child} />
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      {tree.map((node) => (
        <TreeNode key={node.id} node={node} />
      ))}
    </div>
  );
};

export default QuestionTree;
